import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import classes from './payment.module.css';
import { findWebPaymentUser, topUpWebPaymentUser } from '../../../utils/api';

const PAYMENT_OPTIONS = [
    { value: 150, bonus: 0 },
    { value: 300, bonus: 0 },
    { value: 500, bonus: 100 },
    { value: 1000, bonus: 500 },
    { value: 1200, bonus: 600 },
    { value: 2000, bonus: 1600 },
];

const PaymentPage = () => {
    const [query, setQuery] = useState('');
    const [foundUser, setFoundUser] = useState(null);
    const [amount, setAmount] = useState(500);
    const [loadingFind, setLoadingFind] = useState(false);
    const [loadingPay, setLoadingPay] = useState(false);
    const [notice, setNotice] = useState('');
    const [error, setError] = useState('');

    async function onFind() {
        const q = String(query || '').trim();
        if (!q) {
            setError('Введите username или telegram id');
            return;
        }
        setLoadingFind(true);
        setError('');
        setNotice('');
        setFoundUser(null);
        try {
            const user = await findWebPaymentUser(q);
            setFoundUser(user);
        } catch (err) {
            setError(err?.message || 'Пользователь не найден');
        } finally {
            setLoadingFind(false);
        }
    }

    async function onTopUp() {
        if (!foundUser?.id) {
            setError('Сначала найдите пользователя');
            return;
        }
        const normalizedAmount = Number(amount);
        if (!Number.isFinite(normalizedAmount) || normalizedAmount < 10) {
            setError('Минимальная сумма пополнения — 10₽');
            return;
        }
        setLoadingPay(true);
        setError('');
        setNotice('');
        try {
            const paymentUrl = await topUpWebPaymentUser({ clientId: foundUser.id, amount: normalizedAmount });
            if (!paymentUrl) {
                setError('Не удалось создать ссылку на оплату');
                return;
            }
            setNotice(`Переходим к оплате ${normalizedAmount}₽...`);
            window.location.href = paymentUrl;
        } catch (err) {
            setError(err?.message || 'Не удалось создать ссылку на оплату');
        } finally {
            setLoadingPay(false);
        }
    }

    return (
        <div className={classes.page}>
            <div className={classes.wrap}>
                <div className={classes.topRow}>
                    <h1 className={classes.title}>Пополнение баланса</h1>
                    <Link to="/" className={classes.backLink}>На главную</Link>
                </div>

                <div className={classes.card}>
                    <div className={classes.findRow}>
                        <input
                            className={classes.input}
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            placeholder="Username или telegram id"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    onFind();
                                }
                            }}
                        />
                        <button type="button" className={classes.btn} onClick={onFind} disabled={loadingFind}>
                            {loadingFind ? 'Поиск...' : 'Найти'}
                        </button>
                    </div>

                    {error ? <div className={classes.error}>{error}</div> : null}
                    {notice ? <div className={classes.notice}>{notice}</div> : null}

                    {foundUser ? (
                        <div className={classes.result}>
                            <div className={classes.userLine}>
                                Пользователь: <b>{foundUser.telegram_name || foundUser.telegram_login || foundUser.telegram_id}</b>
                            </div>
                            <div className={classes.userLine}>
                                @{foundUser.telegram_login || '—'} / id{foundUser.telegram_id}
                            </div>
                            <div className={classes.userLine}>Текущий баланс: {foundUser.balance || 0}₽</div>

                            <div className={classes.amounts}>
                                {PAYMENT_OPTIONS.map((item) => (
                                    <button
                                        key={item.value}
                                        type="button"
                                        className={`${classes.amountBtn} ${amount === item.value ? classes.amountBtnActive : ''}`}
                                        onClick={() => setAmount(item.value)}
                                    >
                                        {item.value}₽{item.bonus ? ` + ${item.bonus}₽ бонус` : ''}
                                    </button>
                                ))}
                            </div>

                            <div className={classes.amountInputRow}>
                                <div className={classes.userLine}>Или введите произвольную сумму:</div>
                                <input
                                    type="number"
                                    min={10}
                                    className={classes.amountInput}
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value === '' ? '' : Number(e.target.value))}
                                    placeholder="Например, 750"
                                />
                            </div>

                            <button type="button" className={classes.btnPrimary} onClick={onTopUp} disabled={loadingPay}>
                                {loadingPay ? 'Создаем ссылку...' : `Оплатить ${amount}₽`}
                            </button>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default PaymentPage;
